import { Router } from '@angular/router';
import { Component, OnInit, Input } from '@angular/core';
import { BreadCrumb } from '@app/constants/types';
import { ObservatoryService } from '@app/services/services.module';

@Component({
  selector: 'app-bread-crumbs',
  templateUrl: './bread-crumbs.component.html',
  styleUrls: ['./bread-crumbs.component.scss']
})
export class BreadCrumbsComponent implements OnInit {
  @Input() arrayOfBreadCrumbs: BreadCrumb [];
  @Input() sectionName: string;

  constructor(
    private router: Router,
    private observatory: ObservatoryService,

  ) {}

  ngOnInit() {}

  routeTo(route) {
    this.router.navigate([route]);
  }
}
